import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { Table, Popup, Icon } from "semantic-ui-react"

import { withTranslation } from "react-i18next"
import LoadingError from "../../components/shared/LoadingError"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import NoResults from "../../components/shared/NoResults"
import { isFleetAdvise, isMobilease } from "../../helpers/affiliationHelpers"
import ShopListFilter from "./ShopListFilter"
import ShopListItem from "./ShopListItem"
import ShopListShimmer from "./ShopListShimmer"

const PAGE_SEARCH = "search"
const PAGE_FAVORITES = "favorites"

class ShopList extends Component {
  constructor(props) {
    super(props)
    this.setChangedFilter = this.setChangedFilter.bind(this)
    this.state = {
      shopData: [],
      payload: [],
      pageCount: 1,
      displayName: ""
    }
  }

  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoadingError: PropTypes.bool.isRequired,
    onFavoriteSubmit: PropTypes.func.isRequired,
    shops: PropTypes.array.isRequired,
    previousFormData: PropTypes.object
  }

  setChangedFilter(payload, pageCount) {
    this.setState({ payload: payload, shopData: [], pageCount })
  }

  loadMoreItems = () => {
    this.setState(() => {
      return { pageCount: this.props.pageCount + 1 }
    }, this.afterStateUpdate)
  }

  afterShopFilter = () => {
    this.setState((prevState) => ({
      shopData: [...this.props.shops]
    }))
  }

  afterStateUpdate = () => {
    const { dispatch } = this.props
    const { payload, pageCount } = this.state

    if (this.props.activePage === PAGE_FAVORITES) {
      dispatch({
        type: "SHOPS_LOAD_SAGA",
        payload: { pageCount: this.props.favoriteShopPageCount + 1 }
      })

      return
    }

    dispatch({
      type: "SHOPS_FILTER_SAGA",
      payload: { ...payload, pageCount: pageCount },
      callback: this.afterShopFilter
    })
  }

  setDisplayName = (value) => {
    this.setState({ displayName: value })
  }

  render() {
    const {
      isLoading,
      isLoadingError,
      onFavoriteSubmit,
      shops,
      searchMode,
      previousFormData,
      asSubForm,
      handleSelectShop,
      disableSubmit,
      language,
      t,
      totalPages,
      pageCount,
      vehicle_type_id,
      activePage,
      favoriteShops,
      favoriteShopPageCount,
      showHeader
    } = this.props

    const { shopData, displayName } = this.state

    const data = activePage != PAGE_FAVORITES && shopData.length !== 0 ? shopData : shops
    return (
      <div>
        <LoadingError visible={!isLoading && isLoadingError} />

        {searchMode && (
          <div>
            {(asSubForm || showHeader) && (
              <span
                className={`primary-button-color ${
                  isFleetAdvise() || isMobilease() ? "favorite-shop-text-color" : ""
                }`}
              >
                {t("priceByLocationLabel")}
              </span>
            )}
          </div>
        )}
        <ShopListFilter
          asSubForm={asSubForm}
          filterShopsParams={this.props.filterShopsParams}
          setChangedFilter={this.setChangedFilter}
          shopListSetState={this.setState}
          vehicle_type_id={vehicle_type_id}
          onDisplayNameChange={this.setDisplayName}
        />
        {!isFleetAdvise() ? <LoadingThrobber visible={isLoading} /> : null}

        {!isLoading && !isLoadingError ? (
          <div>
            {shops.length ? (
              <Table
                stackable
                basic="very"
                width="100%"
                style={{ marginTop: `${searchMode ? 18 : 2}px` }}
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell></Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                    <Table.HeaderCell>{t("shopLabel")}</Table.HeaderCell>
                    {asSubForm && <Table.HeaderCell>{t("priceLabel")}</Table.HeaderCell>}
                    <Table.HeaderCell>{t("distanceLabel")}</Table.HeaderCell>
                    <Table.HeaderCell>{t("addressLabel")}</Table.HeaderCell>
                    <Table.HeaderCell>{t("ratingLabel")}</Table.HeaderCell>
                    <Table.HeaderCell style={{ whiteSpace: "nowrap" }}>
                      {t("networkLabel")}
                      <Popup
                        position="bottom right"
                        inverted
                        trigger={<Icon name="info circle" style={{ marginLeft: "5px" }} />}
                        content={t(
                          "Shops that are not in-network are part of the Convenience Network and a surcharge will be added to all orders."
                        )}
                        on={["hover", "click"]}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell>{t("transactionsLabel")}</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                    {!asSubForm && <Table.HeaderCell></Table.HeaderCell>}
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data &&
                    data.map((shop, index) => {
                      return (
                        <ShopListItem
                          key={`shop-${index}`}
                          onFavoriteSubmit={onFavoriteSubmit}
                          shop={shop}
                          searchMode={searchMode}
                          previousFormData={previousFormData}
                          asSubForm={asSubForm}
                          handleSelectShop={handleSelectShop}
                          disableSubmit={disableSubmit}
                          language={language}
                          activePage={activePage}
                          displayName={displayName}
                        />
                      )
                    })}
                </Table.Body>
              </Table>
            ) : null}
            {shops.length ? (
              <button
                className="ui tiny button"
                onClick={this.loadMoreItems}
                disabled={
                  totalPages === 0 ||
                  totalPages === 1 ||
                  (activePage && activePage === PAGE_SEARCH && pageCount === totalPages) ||
                  (activePage &&
                    activePage === PAGE_FAVORITES &&
                    favoriteShopPageCount === totalPages) ||
                  (!activePage && pageCount === totalPages)
                }
              >
                {t("seeMore")}
              </button>
            ) : null}
          </div>
        ) : isFleetAdvise() || isMobilease() ? (
          <ShopListShimmer />
        ) : null}

        <NoResults visible={!isLoading && !isLoadingError && shops.length === 0} />
      </div>
    )
  }
} // class ShopList

const mapStateToProps = (state) => ({
  pageCount: state.shops.pageCount,
  favoriteShopPageCount: state.shops.favoriteShopPageCount
})

export default connect(mapStateToProps, null)(withTranslation("shops")(ShopList))
